import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';

export type PinTarget = { targetType: 'folder' | 'videofeed'; targetId: string | number };

export const getContextPins = async (contextType: string, contextParentId: string) => {
  const response = await axiosInstance.get<PinTarget[]>(API_ROUTES.PINNED_CONTENT, {
    params: { contextType, contextParentId },
  });
  return response.data;
};

export const pinContent = async (data: {
  targetType: 'folder' | 'videofeed';
  targetId: string | number;
  contextType: string;
  contextParentId?: string | number | null;
}) => {
  return axiosInstance.post(API_ROUTES.PINNED_CONTENT, data);
};

export const unpinContent = async (data: {
  targetType: 'folder' | 'videofeed';
  targetId: string | number;
  contextType: string;
  contextParentId?: string | number | null;
}) => {
  return axiosInstance.delete(API_ROUTES.PINNED_CONTENT, { data });
};

export const reorderPinnedContent = async (data: {
  contextType: string;
  contextParentId?: string | number | null;
  items: { targetType: 'folder' | 'videofeed'; targetId: string | number }[];
}) => {
  return axiosInstance.patch(`${API_ROUTES.PINNED_CONTENT}/reorder`, data);
};
